import { useIsNodeStaff } from "../is-node-staff";
import { useIsImpersonatedSession } from "../use-is-impersonated-session";

export const useIsNodeOrImpersonated = () => {
  const isNodeStaff = useIsNodeStaff();
  const isImpersonated = useIsImpersonatedSession();

  return isNodeStaff || isImpersonated;
};
